<template>
    <v-container fluid class="pa-1" :style="$vuetify.display.mobile ? 'width: 100vw;' : ''">
        <v-row no-gutters :class="inZTillReceipt.originalDocument ? '' : 'd-flex justify-center'">
            <v-col cols="7" class="pr-1" v-if="!$vuetify.display.mobile">
                <v-card class="default_card_wm elevation-0 pt-2">
                    <DocumentMenu
                        :MenuOptions="documentMenuOptions"
                        @back="back()"
                        @zoom-in="zoomManager.zoomIn()"
                        @zoom-out="zoomManager.zoomOut()"
                        @reset-zoom="zoomManager.resetZoom()"
                        @rotate-left="
                            documentPdfRotation = rotate('left', zoomManager, documentPdfRotation)
                        "
                        @rotate-right="
                            documentPdfRotation = rotate('right', zoomManager, documentPdfRotation)
                        "
                        @download="startDownloadFile"
                        @display-file="((showAccountingLines = false), (displayActivity = false))"
                        @display-accounting-line="
                            ((showAccountingLines = true), (displayActivity = false))
                        "
                        @upload="dialogUploadDocument = true"
                        @activity="((showAccountingLines = false), (displayActivity = true))"
                        @analyse="analyseDocumentDialog = true"
                        @delete="deleteZTillDialog = true"
                    />
                    <v-row no-gutters>
                        <!--
                        <v-col cols="6">
                            <v-btn-back @click.stop="back()" v-if="mode !== 'GeneralLedger'">
                            </v-btn-back>
                            <v-btn-icon
                                icon="$oss-zoom-out"
                                :disabled="zoomManager.disableZoomOut()"
                                class="btn mr-1"
                                color="primary"
                                @click.stop="zoomManager.zoomOut()"
                                v-if="showZoomActions"
                                size="small"
                            />
                            <v-btn-icon
                                icon="$oss-focus"
                                :disabled="zoomManager.disableResetZoom()"
                                class="btn mx-1"
                                color="primary"
                                @click.stop="zoomManager.resetZoom()"
                                v-if="showZoomActions"
                                size="small"
                            />
                            <v-btn-icon
                                icon="$oss-zoom-in"
                                :disabled="zoomManager.disableZoomIn()"
                                class="btn ml-1"
                                color="primary"
                                @click.stop="zoomManager.zoomIn()"
                                v-if="showZoomActions"
                                size="small"
                            />

                            <v-btn-icon
                                class="my-0 mr-1"
                                @click.stop="rotate('left')"
                                icon="$fa-undo"
                            >
                            </v-btn-icon>
                            <v-btn-icon class="my-0" @click.stop="rotate('right')" icon="$fa-redo">
                            </v-btn-icon>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end">
                            <v-btn-icon
                                icon="$oss-download"
                                color="primary"
                                class="mx-1"
                                @click="startDownloadFile"
                                v-if="inZTillReceipt && inZTillReceipt.originalDocument"
                            />
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$dots_vertical"
                                        v-bind="props"
                                        class="mx-1"
                                        color="primary"
                                    />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item
                                        v-if="
                                            isAccountingUser &&
                                            (!!inZTillReceipt.originalDocument || isPDF)
                                        "
                                        @click="
                                            ((showAccountingLines = false),
                                            (displayActivity = false))
                                        "
                                    >
                                        <v-list-item-title>Document</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-file</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="isAccountingUser"
                                        @click="
                                            ((showAccountingLines = true),
                                            (displayActivity = false))
                                        "
                                    >
                                        <v-list-item-title>
                                            Écritures comptables
                                        </v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-accounting-lines</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="dialogUploadDocument = true"
                                        v-if="!inZTillReceipt.originalDocument && !isPDF"
                                    >
                                        <v-list-item-title>
                                            Importer un document
                                        </v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-file</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            ((showAccountingLines = false),
                                            (displayActivity = true))
                                        "
                                        v-if="isAccountingUser"
                                    >
                                        <v-list-item-title> Afficher l'activité </v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="analyseDocumentDialog = true"
                                        v-if="restartAnalysis"
                                    >
                                        <v-list-item-title> Relancer l'analyse </v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-scan</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mb-2" />
                                    <v-list-item
                                        @click="deleteZTillDialog = true"
                                        color="error"
                                        :active="true"
                                    >
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>-->
                        <template v-if="showAccountingLines">
                            <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                                <accounting-item-static
                                    :companyId="companyId"
                                    :zTillReceiptId="inZTillReceipt.id"
                                    mode="Embedded"
                                    ref="accountingItemStatic"
                                />
                                <v-alert
                                    type="warning"
                                    class="mt-2"
                                    absolute
                                    v-if="zTillHasChanged"
                                    :model-value="true"
                                >
                                    Le document a été modifié. Enregistrez les modifications pour
                                    actualiser les lignes comptables
                                </v-alert>
                            </v-col>
                        </template>
                        <template v-else-if="displayActivity">
                            <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                                <UsersActivitiesHistory :zTillReceiptId="inZTillReceipt.id" />
                            </v-col>
                        </template>
                        <template v-else>
                            <v-col
                                cols="12"
                                class="d-flex justify-center"
                                v-if="isPDF"
                                style="height: calc(100vh - 130px); overflow-y: auto"
                            >
                                <ossPdf
                                    :rotation="documentPdfRotation"
                                    :documentId="inZTillReceipt.originalDocument.id"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                style="height: calc(100vh - 130px); overflow-y: auto"
                                v-else
                            >
                                <div
                                    style="
                                        position: relative;
                                        width: 100%;
                                        height: 0;
                                        padding: 0;
                                        padding-bottom: 141.4516129032258%;
                                        margin-bottom: 50px;
                                    "
                                >
                                    <svg
                                        id="svg-zTillReceipt"
                                        v-if="inZTillReceipt && inZTillReceipt.originalDocument"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="100%"
                                        :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                        style="
                                            position: absolute;
                                            width: 100%;
                                            left: 0;
                                            top: 0;
                                            background: #fff;
                                        "
                                    >
                                        <image
                                            id="svg-image-zTillReceipt"
                                            :xlink:href="inZTillReceipt.originalDocument.signedUrl"
                                            x="0"
                                            y="0"
                                            :height="`${imageHeight}px`"
                                            :width="`${imageWidth}px`"
                                        />
                                    </svg>
                                </div>
                            </v-col>
                        </template>
                    </v-row>
                </v-card>
            </v-col>
            <v-col :cols="$vuetify.display.mobile ? 12 : 5" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                        height: calc(100vh - 82px);
                        overflow-y: auto;
                    "
                    class="default_card_wm elevation-0 rounded-l-0"
                >
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-list-item :ripple="false" class="oss-list-item mb-2" color="success">
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters>
                                        <v-col
                                            cols="3"
                                            class="d-flex align-center"
                                            style="border-right: 1px #ededed solid"
                                        >
                                            <b>Statut</b>
                                        </v-col>
                                        <v-col cols="9" class="d-flex align-center pl-2">
                                            <!-- <div v-if="inZTillReceipt.originalDocument.type === 'UNKNOWN'">Choisissez le type du document</div> -->
                                            <div
                                                v-if="
                                                    processAnalysis &&
                                                    !inZTillReceipt.originalDocument.errorMessage
                                                "
                                            >
                                                En attente d'analyse par le cabinet
                                            </div>
                                            <div
                                                v-else-if="
                                                    reUploadDocument &&
                                                    inZTillReceipt.originalDocument.errorMessage
                                                "
                                                style="color: red"
                                            >
                                                Erreur :
                                                {{ inZTillReceipt.originalDocument.errorMessage }}
                                            </div>
                                            <div
                                                v-else-if="
                                                    reUploadDocumentClient &&
                                                    inZTillReceipt.originalDocument.errorMessage
                                                "
                                                style="color: red"
                                            >
                                                Erreur de lecture du fichier : contacter votre
                                                cabinet
                                            </div>
                                            <div v-else>{{ ztillStatus }}</div>
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                        </v-col>
                    </v-row>
                    <template v-if="toValidate || validated || forceForm">
                        <v-window v-model="windowStep" touchless v-if="!processAnalysis">
                            <v-window-item :step="0">
                                <!-- <v-row no-gutters class="my-2 py-3 px-2 oss-list-item">
                                        <v-col cols="12">
                                            <v-row no-gutters class="align-center">
                                                <v-col cols="3"  style="border-right: solid rgba(0, 0, 0, 0.12) 1px">
                                                    <b>Statut</b>
                                                </v-col>
                                                <v-col cols="9" class="pl-2">
                                                    {{ ztillStatus }}
                                                    <v-spacer></v-spacer>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row> -->
                                <v-row no-gutters class="pt-1">
                                    <v-col cols="6" class="pr-1">
                                        <template v-if="period === 'WE'">
                                            <oss-date-picker
                                                v-model="week"
                                                :hide-details="true"
                                                :label="$t('shared.date')"
                                                :mandatory="false"
                                                :textFieldReadOnly="false"
                                                :type="month ? 'month' : 'date'"
                                                :filterWithoutClosedAccountingPeriods="true"
                                            />
                                        </template>
                                        <template v-else>
                                            <oss-date-picker
                                                v-model="date"
                                                :hide-details="true"
                                                :label="$t('shared.date')"
                                                :mandatory="false"
                                                :textFieldReadOnly="false"
                                                :type="month ? 'month' : 'date'"
                                                :filterWithoutClosedAccountingPeriods="true"
                                            />
                                        </template>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select-filled
                                            v-model="period"
                                            :items="periods"
                                            label="Période"
                                            item-value="key"
                                            item-title="value"
                                            density="compact"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <FreeTag
                                            v-if="inZTillReceipt && inZTillReceipt.document"
                                            :companyTags="allCompanyTags"
                                            :company="company"
                                            :document="inZTillReceipt.document"
                                            :splitUserPartitions="true"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="py-2 pt-3">
                                    <v-col cols="2" class="d-flex align-center col-auto pr-3 title">
                                        Ventes
                                    </v-col>
                                    <v-col cols="9" class="d-flex align-center">
                                        <v-divider />
                                    </v-col>
                                    <v-col cols="1" class="d-flex align-center col-auto pl-3 title">
                                        <v-btn-add-icon size="x-small" @click="addLine()">
                                        </v-btn-add-icon>
                                    </v-col>
                                </v-row>
                                <template v-if="incomes && incomes.length">
                                    <div style="overflow-y: auto">
                                        <v-row
                                            no-gutters
                                            v-for="(income, index) in incomes"
                                            :key="index"
                                        >
                                            <v-col cols="11">
                                                <v-row no-gutters class="py-1">
                                                    <v-col cols="6" class="pr-1">
                                                        <v-select-filled
                                                            :hide-details="true"
                                                            v-model="income.accountableAccount"
                                                            :items="salesAccountableAccounts"
                                                            label="Type de recette"
                                                            item-value="name"
                                                            single-line
                                                            density="compact"
                                                            :item-title="(item) => item.description"
                                                        />
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <oss-text-field-filled
                                                            regular
                                                            dense
                                                            :hide-details="true"
                                                            label="Dont offert"
                                                            outlined
                                                            v-model="income.freeAmount"
                                                        />
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters>
                                                    <v-col class="py-1 pr-1">
                                                        <oss-text-field-filled
                                                            regular
                                                            dense
                                                            :hide-details="true"
                                                            outlined
                                                            label="HT"
                                                            readonly
                                                            disabled
                                                            v-model="income.netAmount"
                                                        />
                                                    </v-col>
                                                    <v-col class="py-1 pr-1">
                                                        <oss-text-field-filled
                                                            label="TVA"
                                                            regular
                                                            dense
                                                            :hide-details="true"
                                                            outlined
                                                            readonly
                                                            disabled
                                                            v-model="income.vatAmount"
                                                        />
                                                    </v-col>
                                                    <v-col class="py-1 pr-1">
                                                        <oss-text-field-filled
                                                            density="compact"
                                                            :hide-details="true"
                                                            label="TTC"
                                                            @update:model-value="TTCPrice(income)"
                                                            v-model="income.grossAmount"
                                                        />
                                                    </v-col>
                                                    <v-col class="py-1 pr-1">
                                                        <v-select-filled
                                                            :items="vatRates"
                                                            :hide-details="true"
                                                            label="Taux de TVA"
                                                            @update:model-value="
                                                                VATRate(income, $event)
                                                            "
                                                            :model-value="
                                                                income.vatType === 'INTRACOM'
                                                                    ? '0INTRACOM'
                                                                    : income.vatRate
                                                            "
                                                            density="compact"
                                                        />
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters>
                                                    <v-col cols="12">
                                                        <FreeTag
                                                            :companyTags="allCompanyTags"
                                                            :document="income.document"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col
                                                cols="1"
                                                class="d-flex align-center justify-center"
                                            >
                                                <v-btn-trash
                                                    v-if="incomes.length > 1"
                                                    @click="deleteCategory(income)"
                                                />
                                            </v-col>
                                            <v-col cols="12" v-if="index < incomes.length - 1">
                                                <v-divider class="my-2" />
                                            </v-col>
                                        </v-row>
                                        <!-- Total -->
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-row no-gutters class="py-2 pt-5">
                                                    <v-col
                                                        class="d-flex align-center col-auto pr-3"
                                                    >
                                                        Total
                                                    </v-col>
                                                    <v-col cols="9" class="d-flex align-center">
                                                        <v-divider />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters>
                                            <v-col class="pr-1">
                                                <oss-text-field-filled
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    label="HT"
                                                    outlined
                                                    readonly
                                                    :model-value="
                                                        newCommonFormatCurrency(
                                                            totalNetAmount,
                                                            undefined,
                                                        )
                                                    "
                                                />
                                            </v-col>
                                            <v-col class="pr-1">
                                                <oss-text-field-filled
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    label="TVA"
                                                    outlined
                                                    readonly
                                                    :model-value="
                                                        newCommonFormatCurrency(
                                                            totalVatAmount,
                                                            undefined,
                                                        )
                                                    "
                                                />
                                            </v-col>
                                            <v-col class="pr-1">
                                                <oss-text-field-filled
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    label="TTC"
                                                    outlined
                                                    readonly
                                                    :model-value="
                                                        newCommonFormatCurrency(
                                                            totalGrossAmount,
                                                            undefined,
                                                        )
                                                    "
                                                />
                                            </v-col>
                                            <v-col class="pr-1"> </v-col>
                                            <v-col cols="1"> </v-col>
                                        </v-row>
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-row no-gutters class="py-2 pt-5">
                                                    <v-col
                                                        class="d-flex align-center col-auto pr-3"
                                                    >
                                                        Commission | Frais
                                                    </v-col>
                                                    <v-col cols="9" class="d-flex align-center">
                                                        <v-divider />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters>
                                            <v-col class="py-1 pr-1">
                                                <oss-text-field-filled
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    outlined
                                                    label="HT"
                                                    readonly
                                                    disabled
                                                    v-model="commission.netAmount"
                                                />
                                            </v-col>
                                            <v-col class="py-1 pr-1">
                                                <oss-text-field-filled
                                                    label="TVA"
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    outlined
                                                    readonly
                                                    disabled
                                                    v-model="commission.vatAmount"
                                                />
                                            </v-col>
                                            <v-col class="py-1 pr-1">
                                                <oss-text-field-filled
                                                    density="compact"
                                                    :hide-details="true"
                                                    label="TTC"
                                                    @update:model-value="TTCPrice(commission)"
                                                    v-model="commission.grossAmount"
                                                />
                                            </v-col>
                                            <v-col class="py-1 pr-1">
                                                <v-select-filled
                                                    :items="vatRates"
                                                    :hide-details="true"
                                                    label="Taux de TVA"
                                                    @update:model-value="
                                                        VATRate(commission, $event)
                                                    "
                                                    :model-value="
                                                        commission.vatType
                                                            ? commission.vatRate.toString() +
                                                              commission.vatType
                                                            : commission.vatRate
                                                    "
                                                    density="compact"
                                                />
                                            </v-col>
                                            <v-col cols="1"> </v-col>
                                        </v-row>
                                        <!-- additional amounts -->
                                        <v-row no-gutters class="py-2 pt-3">
                                            <v-col
                                                cols="2"
                                                class="d-flex align-center col-auto pr-3 title"
                                            >
                                                Montants supplémentaires
                                            </v-col>
                                            <v-col cols="9" class="d-flex align-center">
                                                <v-divider />
                                            </v-col>
                                            <v-col
                                                cols="1"
                                                class="d-flex align-center col-auto pl-3 title"
                                            >
                                                <v-btn-add-icon
                                                    size="x-small"
                                                    @click="addAdditionalAmount()"
                                                >
                                                </v-btn-add-icon>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            no-gutters
                                            v-for="(additionalAmount, index) of additionalAmounts"
                                            :key="index"
                                            class="pt-1"
                                        >
                                            <v-col class="pr-1">
                                                {{ additionalAmount.name }}
                                                <v-text-field-filled
                                                    model-value="additionalAmount.name"
                                                    :readonly="true"
                                                >
                                                </v-text-field-filled>
                                            </v-col>
                                            <v-col class="pr-1">
                                                <oss-text-field-filled
                                                    suffix="&#x20ac;"
                                                    dense
                                                    single-line
                                                    :hide-details="true"
                                                    v-model="additionalAmount.amountSigned"
                                                />
                                            </v-col>
                                            <v-col cols="1">
                                                <v-btn-trash
                                                    v-if="additionalAmounts.length >= 1"
                                                    @click="
                                                        deleteAdditionalAmount(additionalAmount)
                                                    "
                                                />
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                                <template v-else>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex justify-center">
                                            Aucunes données enregistrées
                                        </v-col>
                                        <v-col cols="12" class="d-flex justify-center">
                                            <v-btn size="small" @click="addLine()">
                                                Ajouter une ligne
                                                <v-icon left size="small">$add</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-if="withTransactions">
                                    <v-row no-gutters class="py-2 pt-3">
                                        <v-col
                                            cols="2"
                                            class="d-flex align-center col-auto pr-3 title"
                                        >
                                            Encaissement
                                        </v-col>
                                        <v-col cols="9" class="d-flex align-center">
                                            <v-divider />
                                        </v-col>
                                        <v-col
                                            cols="1"
                                            class="d-flex align-center col-auto pl-3 title"
                                        >
                                            <v-btn-add-icon
                                                size="x-small"
                                                @click="addTransaction()"
                                            >
                                            </v-btn-add-icon>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        v-for="(transaction, index) of transactions"
                                        :key="index"
                                        class="pt-1"
                                    >
                                        <v-col class="pr-1">
                                            <v-select-filled
                                                v-model="transaction.name"
                                                :items="transactionDefaultAccountableAccounts"
                                                label="Type de transaction"
                                                :item-title="getDescription"
                                                item-value="name"
                                                :hide-details="true"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col class="pr-1">
                                            <oss-text-field-filled
                                                label="Montant"
                                                suffix="&#x20ac;"
                                                dense
                                                single-line
                                                :hide-details="true"
                                                v-model="transaction.amount"
                                            />
                                        </v-col>
                                        <v-col cols="1">
                                            <v-btn-trash
                                                v-if="transactions.length > 1"
                                                @click="deleteTransaction(transaction)"
                                            />
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-if="diff">
                                    <v-row no-gutters class="py-2 pt-3">
                                        <v-col class="d-flex align-center col-auto pr-3 title">
                                            Ecart
                                        </v-col>
                                        <v-col class="d-flex align-center">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-1">
                                        <v-col class="pr-1">
                                            <v-text-field-filled
                                                value="Ecart"
                                                rounded
                                                readonly
                                                hide-details
                                                outlined
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col class="pr-1">
                                            <oss-text-field-filled
                                                suffix="&#x20ac;"
                                                dense
                                                :hide-details="true"
                                                readonly
                                                v-model="diff"
                                            />
                                        </v-col>
                                        <v-col cols="1"> </v-col>
                                    </v-row>
                                </template>
                            </v-window-item>
                        </v-window>
                        <v-card-actions class="d-flex justify-end mb-10" v-if="!processAnalysis">
                            <DocumentValidationSpeedRun
                                v-if="displayDocumentValidationSpeedRun(document.status)"
                                v-model="lastTicketZValidationDone"
                            />
                            <v-btn
                                class="mx-1"
                                :disabled="!status"
                                @click="validPage()"
                                :loading="loading"
                                size="small"
                            >
                                {{ validated ? "Validé" : "Valider" }}
                                <v-icon v-show="validated">$check</v-icon>
                            </v-btn>
                            <v-btn-prev
                                v-if="mode !== 'GeneralLedger'"
                                :disabled="previousDisabled()"
                                @click="previous()"
                            />
                            <v-btn-next
                                v-if="mode !== 'GeneralLedger'"
                                :disabled="nextDisabled()"
                                @click="next()"
                            />
                        </v-card-actions>
                    </template>
                    <template v-else>
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex justify-end">
                                <v-btn @click="forceForm = true" size="small">
                                    Passer à la validation
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="800px">
            Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

            <template v-slot:actions>
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(true);
                            "
                            size="x-large"
                            >Original</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(false);
                            "
                            size="x-large"
                            >Marqué</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="
                analyseDocumentDialog = false;
                analyseDocument();
            "
            valid-title="Oui"
            width="800px"
        >
            <v-card-text class="text-center"
                >&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</v-card-text
            >
        </oss-dialog>
        <oss-dialog
            v-model="deleteZTillDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteZTill"
            :validTitle="'Oui je suis sûr(e)'"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer Z de caisse ?</h4>
        </oss-dialog>

        <oss-dialog
            v-model="dialogUploadDocument"
            title="Importer un document pour cette OD"
            v-if="inZTillReceipt"
            max-width="60vw"
        >
            <UploadDocument
                :showFirstPrevious="false"
                :companyId="companyId"
                :documentId="
                    inZTillReceipt.originalDocument ? inZTillReceipt.originalDocument.id : null
                "
                documentType="ZTILL_RECEIPT"
                :multiple="false"
                :freeTag="false"
                :showBtns="true"
                @file="linkFile($event)"
            />
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import { TicketZEditionBase } from "./TicketZEditionBase";
import ossPdf from "../document/DocumentPDF.vue";

import ANALYSE_DOCUMENT from "../../graphql/document/AnalyseDocument.gql";

import AccountingItemStatic from "../AccountingItemStatic.vue";
import UploadDocument from "../document/UploadDocuments.vue";
import AccountableAccount from "../AccountableAccount.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import { ZoomManager } from "../../services/zoomManager";
import { getSiretValue } from "../../../src/services/companyServices";
import { vatRatesZTillReceipt } from "../../services/vatServices";
import getEnv from "@/env";
import { Component, toNative } from "vue-facing-decorator";
import { isNoValidatedDocument } from "../document/DocumentValidationSpeedRun.helper";
import { DocumentMenu } from "../document/DocumentMenu.vue";

import {
    MenuDisplayDotMenuOptions,
    MenuDisplayRotationOptions,
    MenuDisplayDownloadOptions,
    MenuDisplayOptions,
    MenuDisplayZoomOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";
import { zoom } from "svg-pan-zoom";

const env = getEnv();

@Component({
    components: {
        ossPdf,
        AccountingItemStatic,
        UploadDocument,
        AccountableAccount,
        UsersActivitiesHistory,
        DocumentMenu,
    },
    emits: ["updateZTill"],
})
export class TicketZEditionWithDocument extends TicketZEditionBase {
    /**
     * Used for rotation of ossPdf
     */
    documentPdfRotation: number = 0;

    analyseDocumentDialog: boolean = false;

    dialogChooseDownload = false;

    wizardStep = "ticketZTable";

    dialogUploadDocument: boolean = false;
    showAccountingLines: boolean = false;
    windowStep = 0;

    zTillHasChanged: boolean = false;
    zoomManager = null;

    forceForm = false;
    deleteZTillDialog = false;

    displayActivity = false;

    get documentMenuZoomOptions(): MenuDisplayZoomOptions {
        const zoomOptions: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomOptions.isDisplay = this.showZoomActions;
        zoomOptions.isResetZoomDisabled = this.zoomManager.disableResetZoom();
        zoomOptions.isZoomInDisabled = this.zoomManager.disableZoomIn();
        zoomOptions.isZoomOutDisabled = this.zoomManager.disableZoomOut();

        return zoomOptions;
    }

    get documentMenuDownloadOptions(): MenuDisplayDownloadOptions {
        const downloadOptions: MenuDisplayDownloadOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.downloadButton,
        };

        downloadOptions.isDisplay = !!this.inZTillReceipt && !!this.inZTillReceipt.originalDocument;

        return downloadOptions;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenuOptions: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenuOptions.isDisplay = true;

        dotMenuOptions.document.isDisplay =
            this.isAccountingUser && (!!this.inZTillReceipt.originalDocument || this.isPDF);
        dotMenuOptions.document.title = "Document";

        dotMenuOptions.accountingLine.isDisplay = this.isAccountingUser;
        dotMenuOptions.accountingLine.title = "Écritures comptables";

        dotMenuOptions.upload.isDisplay = !this.inZTillReceipt.originalDocument && !this.isPDF;
        dotMenuOptions.upload.title = "Importer un document";

        dotMenuOptions.activity.isDisplay = this.isAccountingUser;
        dotMenuOptions.activity.title = "Afficher l'activité";

        dotMenuOptions.analyse.isDisplay = this.restartAnalysis;
        dotMenuOptions.analyse.title = "Relancer l'analyse";

        dotMenuOptions.delete.isDisplay = true;
        dotMenuOptions.delete.title = "Supprimer";

        return dotMenuOptions;
    }

    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        let rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };

        rotationButton.isDisplay = this.showRotateActions;

        return rotationButton;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = {
            ...documentMenuDisplayOptionsDefaultScheme,
        };

        documentMenuOption.zoomButtons = this.documentMenuZoomOptions;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.downloadButton = this.documentMenuDownloadOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    beforeMount() {
        this.creationMode = "edition";
        this.onBeforeMountCommon();
        if (!this.incomes.length) {
            this.addLine();
        }
        if (!this.inZTillReceipt.originalDocument && this.isAccountingUser) {
            this.showAccountingLines = true;
        }
        this.zTillHasChanged = false;
        this.zoomManager = new ZoomManager();
        if (this.inZTillReceipt.originalDocument && !this.isPDF) {
            this.zoomManager.instanciateSvgZoom("zTillReceipt");
        }
        this.finishMounted();
    }

    download() {
        window.open(`${env.VUE_APP_BACKEND}/zTill/download/${this.inZTillReceipt.id}`, "_blank");
    }

    addLine() {
        // debugger
        let accountableAccount = "";
        if (
            this.salesAccountableAccounts &&
            this.salesAccountableAccounts.length &&
            this.salesAccountableAccounts.length === 1
        ) {
            accountableAccount = this.salesAccountableAccounts[0]?.name || null;
        }
        this.incomes.push({
            accountableAccount: accountableAccount,
            netAmount: 0,
            grossAmount: 0,
            vatAmount: 0,
            vatRate: 20,
            vatType: null,
            freeAmount: 0,
        });
    }

    get originalDocumentId() {
        if (this.inZTillReceipt && this.inZTillReceipt.originalDocument) {
            return this.inZTillReceipt.originalDocument.id;
        }
        return "";
    }

    get processAnalysis() {
        if (
            this.inZTillReceipt.originalDocument &&
            this.inZTillReceipt.originalDocument.status &&
            (this.inZTillReceipt.originalDocument.status === "ORIGINAL_UPLOADED" ||
                this.inZTillReceipt.originalDocument.status === "UPLOADED")
        ) {
            return true;
        }
        return false;
    }

    get showZoomActions() {
        if (this.isPDF) return false;
        return (
            this.inZTillReceipt.originalDocument && !!this.inZTillReceipt.originalDocument.signedUrl
        );
    }

    get showRotateActions() {
        return (
            this.inZTillReceipt.originalDocument && !!this.inZTillReceipt.originalDocument.signedUrl
        );
    }

    get vatList() {
        return vatRatesZTillReceipt;
    }

    async analyseDocument() {
        if (!this.restartAnalysis) return;
        await this.$apollo.mutate({
            mutation: ANALYSE_DOCUMENT,
            variables: {
                id: this.originalDocumentId,
            },
        });
        try {
            this.createUserActivity(this.inZTillReceipt.id, "UPDATE");
        } catch (e) {
            console.error(e);
        }
    }

    get restartAnalysis() {
        if (!this.isAccountingUser) return false;
        return !!this.originalDocumentId;
    }

    get reUploadDocument() {
        if (!this.inZTillReceipt || !this.inZTillReceipt.originalDocument) return false;
        if (
            this.inZTillReceipt.originalDocument.status === "ORIGINAL_UPLOADED" &&
            this.currentUser.profile.configuration.document.write
        ) {
            return true;
        }
        return false;
    }

    get reUploadDocumentClient() {
        if (!this.inZTillReceipt || !this.inZTillReceipt.originalDocument) return false;
        if (this.inZTillReceipt.originalDocument.status === "ORIGINAL_UPLOADED") {
            return true;
        }
        return false;
    }

    startDownloadFile() {
        // this.dialogChooseDownload = true
        this.downloadFile(true);
    }

    downloadFile(original) {
        debugger;
        if (!this.originalDocumentId) return;
        if (original) {
            window.open(
                `${env.VUE_APP_BACKEND}/document/download/${this.originalDocumentId}/original`,
                "_blank",
            );
        } else {
            window.open(
                `${env.VUE_APP_BACKEND}/document/download/${this.originalDocumentId}`,
                "_blank",
            );
        }
    }

    back() {
        this.$router.go(-1);
    }

    async validPage() {
        await this.valid();
        this.$emit("updateZTill");
    }

    async linkFile(data) {
        this.file = data.file;
        // this.tags = data.tags // DO NOT MODIFY TAG FROM UPLOAD
        this.status = true;
        await this.valid();
    }

    get imageWidth() {
        if (!this.inZTillReceipt || !this.inZTillReceipt.originalDocument) {
            return 20.0;
        }
        const document = this.inZTillReceipt.originalDocument;
        return document.workingCopy
            ? document.workingCopy.width
            : document.original
              ? document.original.width || 20.0
              : 20.0;
    }

    get imageHeight() {
        if (!this.inZTillReceipt || !this.inZTillReceipt.originalDocument) {
            return 20.0;
        }
        const document = this.inZTillReceipt.originalDocument;
        return document.workingCopy
            ? document.workingCopy.height
            : document.original
              ? document.original.height || 20.0
              : 20.0;
    }

    get ztillStatus() {
        if (this.inZTillReceipt?.document?.status) {
            return this.$t("document.status." + this.inZTillReceipt.document.status).toString();
        }
        if (this.inZTillReceipt?.originalDocument?.status) {
            return this.$t(
                "document.status." + this.inZTillReceipt.originalDocument.status,
            ).toString();
        }
        return "";
    }

    get validated() {
        if (this.inZTillReceipt?.document?.status?.includes("VALIDATED")) {
            return true;
        }
        if (this.inZTillReceipt?.originalDocument?.status?.includes("VALIDATED")) {
            return true;
        }
        return false;
    }

    get toValidate() {
        if (this.inZTillReceipt?.document?.status?.includes("ANALYSED")) {
            return true;
        }
        if (this.inZTillReceipt?.originalDocument?.status?.includes("ANALYSED")) {
            return true;
        }
        return false;
    }

    /**
     * Rotates the page in the PDF component.
     * @param direction The direction to rotate the component.
     * @param zoomManager The zoomManager instance given.
     * @param documentPdfRotation The local rotation of the document.
     */
    rotate(direction: "right" | "left", zoomManager: ZoomManager, documentPdfRotation: number) {
        if (!this.isPDF) {
            switch (direction) {
                case "right":
                    zoomManager.rotateSvg((documentPdfRotation + 90) % 360);
                    break;
                case "left":
                    zoomManager.rotateSvg((documentPdfRotation - 90) % 360);
                    break;
            }
        } else {
            return (documentPdfRotation + (direction === "right" ? 90 : -90)) % 360;
        }
        return 0;
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    displayDocumentValidationSpeedRun(documentStatus: string) {
        return isNoValidatedDocument(documentStatus);
    }
}

export default toNative(TicketZEditionWithDocument);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
